
/**
 * @param {{commonHeader:string}} data
 */
import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import PageMeta from "../../components/PageMeta";
import ComponentComposer from "../../components/ComponentComposer";
import { fetchCountdownCalendar } from "../../api/cms";
import AnalyticsPageLoad from "../../components/AnalyticsPageLoad/AnalyticsPageLoad";
import "./styles.scss";
import RedirectComponent from "../../components/RedirectPage";
import utils from "../../components/TossUpChallenge/code/js/utils";

const CountdownCalendarPage: React.FC<any> = ({ confirm = false }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [page, setPage] = useState<any>([]);
  const [ogMetaTags, setOgMetaTags] = useState<any>({});
  const [sitePageTitle, setPageTitle] =useState("wof");
  const [basicMetaTags, setBasicMetaTags] = useState<any>({});
  const [twitterMetaTags, setTwitterMetaTags] = useState<any>({});
  const { countdowncalendar } = useParams();
  const location = useLocation();
  const [dataError, setDataError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let urlParam = countdowncalendar;
      if (countdowncalendar !== undefined) {
        urlParam = countdowncalendar;
      }

      const fetchApi = fetchCountdownCalendar;
      const _data = await fetchApi(urlParam);
      utils.trace('urlParam ' + urlParam);

      // Validation for empty array or error message.
      // API returns error as true or empty array.
      if (_data.error === true || _data.length === 0) {
        setDataError(true);
        return;
      }
      else {
        setIsLoaded(true);
        if (_data.components) {
          for (var i = 0; i < _data.components.length; i++) {
            _data.components[i].data.componentId = "component-position-" + i;
          }
        }
        setData(_data.components);
        setPage(_data.page);

        if (_data.page && _data.page.og_meta_tags && _data.page.og_meta_tags !== "") {
          setOgMetaTags(_data.page.og_meta_tags);
        }
        if (_data.page && _data.page.page_title && _data.page.page_title !== "") {
          setPageTitle(_data.page.page_title);
        }

        if (_data.page && _data.page.basic_meta_tags && _data.page.basic_meta_tags !== "") {
          setBasicMetaTags(_data.page.basic_meta_tags);
        }

        if (_data.page && _data.page.twitter_meta_tags && _data.page.twitter_meta_tags !== "") {
          setTwitterMetaTags(_data.page.twitter_meta_tags);
        }

        if (_data.page && _data.page.redirect) {
          window.location.replace(_data.page.redirect);
        }
      }
    };

    fetchData();

    // Add custom class to component when is embed or not.
    if (location.pathname.includes('/play/embed/countdown-calendar/')) {
      document.body.className += "body-embed-countdown-calendar-page";
    }
    else if (location.pathname.includes('/play/countdown-calendar/')) {
      document.body.className += "body-embed-countdown-calendar-page";
    }
  }, [countdowncalendar, location.pathname]);

  return (
    <>
      { (!dataError) ? (
        <div id="countdown-calendar-page" className="countdown-calendar-page wof-react-component remove-bg">
          {isLoaded && <AnalyticsPageLoad contentTitle={sitePageTitle} />}
          <PageMeta
            sitePageTitle={sitePageTitle}
            ogMetaTags={ogMetaTags}
            basicMetaTags={basicMetaTags}
            twitterMetaTags={twitterMetaTags}
          />
          {data && data.map((d, i) => <ComponentComposer key={i} {...d} />)}
        </div>
        ) : (
          <RedirectComponent/>
        )
      }
    </>
  );
}

export default CountdownCalendarPage;
